import { Icon } from '../primitives';
import { useTranslation } from 'react-i18next';

/**
 * CreateCloseButton — белая pill-кнопка со значком clear под CreatePopup-ом.
 *
 * Figma source: `318:3506` (button) в overlay `318:3434`.
 *
 * Geometry (FIXED per Figma, figma-spec §1+§2):
 *   - size    : 115×48
 *   - layout  : HORIZONTAL, padding [4, 0, 4, 0]
 *   - primaryAxisAlignItems=CENTER, counterAxisAlignItems=CENTER
 *   - radius  : 48 (pill, home-48 token)
 *
 * Fill: white SOLID (base-white).
 * Effect: backdropBlur 80px (на 100% непрозрачном фоне не виден, но
 * оставляем для edge-case per figma-spec §1).
 *
 * Child: icon variant=clear (248:6603) 24×24 чёрный. Остальные 4
 * icon-child-а в Figma `visible:false` — мы их вообще не рендерим.
 *
 * a11y: aria-label="Закрыть" — единственная семантика кнопки.
 */
export default function CreateCloseButton({ onClick }) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={t('common.close', 'Закрыть')}
      className={[
        'inline-flex items-center justify-center',
        'w-[115px] h-[48px]',
        'rounded-home-48',
        'bg-base-white',
        'backdrop-blur-close-btn',
        'text-text-inverse',
      ].join(' ')}
    >
      <Icon name="clear" size={24} />
    </button>
  );
}
